import { h } from "preact";
import { useState, useMemo, useCallback } from "preact/hooks";
import { photos as allPhotos } from "./data.js";
import { Grid } from "./Grid.js";
import { Lightbox } from "./Lightbox.js";

const FILTERS = [
  { id: "all",   label: "Все" },
  { id: "pvd",   label: "ПВД" },
  { id: "craft", label: "Крафт" },
  { id: "zip",   label: "ЗИП" },
];

export function Gallery() {
  const [filter, setFilter] = useState("all");
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const filteredPhotos = useMemo(() => {
    if (filter === "all") return allPhotos;
    return allPhotos.filter((p) => p.category === filter);
  }, [filter]);

  const open = useCallback((index) => setLightboxIndex(index), []);
  const close = useCallback(() => setLightboxIndex(null), []);

  return h("div", { class: "gallery" },
    // Фильтры
    h("div", { class: "gallery__filters", role: "tablist" },
      FILTERS.map((f) =>
        h("button", {
          key: f.id,
          type: "button",
          role: "tab",
          "aria-selected": filter === f.id,
          class: "gallery__filter" + (filter === f.id ? " is--active" : ""),
          onClick: () => setFilter(f.id),
        }, f.label)
      )
    ),

    // Сетка
    h(Grid, {
      photos: filteredPhotos,
      onOpen: open,
    }),

    // Лайтбокс
    lightboxIndex !== null && h(Lightbox, {
      photos: filteredPhotos,
      index: lightboxIndex,
      onClose: close,
      onChange: setLightboxIndex,
    })
  );
}
